export default __webpack_public_path__ + "static/media/expl_07_DE.2fccf1a6.png";